import { render, staticRenderFns } from "./addChannelAccountDialog.vue?vue&type=template&id=aebca186&scoped=true"
import script from "./addChannelAccountDialog.vue?vue&type=script&lang=js"
export * from "./addChannelAccountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebca186",
  null
  
)

export default component.exports